import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { QuillModule } from 'ngx-quill';
import { ChatAvatarModule } from '../chat-avatar/chat-avatar.module';
import { ChatInputComponent } from './chat-input.component';

@NgModule({
  declarations: [ChatInputComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    FontAwesomeModule,
    QuillModule,
    ChatAvatarModule,
  ],
  exports: [ChatInputComponent],
})
export class ChatInputModule {}
